import {
  ArrowRightOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSwiper } from "swiper/react";

export default function Heading({
  title = "Tiêu đề",
  linkTo,
  isShowButtonMore = true,
  handlePrev,
  handleNext,
  className = "",
}) {
  const [disabled, setDisabled] = useState("start");
  const swiper = useSwiper();

  useEffect(() => {
    if (!swiper) return;
    swiper.on("slideChange", function () {
      setDisabled("");
    });
    swiper.on("reachBeginning", function () {
      setTimeout(() => {
        setDisabled("start");
      }, 100);
    });
    swiper.on("reachEnd", function () {
      setTimeout(() => {
        setDisabled("end");
      }, 100);
    });
  }, []);

  return (
    <div className="flex items-center justify-between">
      <h3 className="sm:text-[26px] text-[#222222]	text-lg font-bold">
        {title}
      </h3>
      <div className="flex sm:gap-[30px] gap-[10px]">
        {linkTo && (
          <Link
            className="flex items-center sm:text-[14px] text-[12px]"
            to={linkTo}
          >
            <span className="">Xem thêm</span>
            <ArrowRightOutlined className="sm:text-[10px] ml-[8px] text-[8px]" />
          </Link>
        )}

        {isShowButtonMore && (
          <div className="flex sm:text-[23px] text-[11px] sm:gap-[13px] gap-[5px]">
            <button
              className={
                "shadow-none sm:w-[38px] sm:h-[38px] w-[16px] h-[16px] rounded-[10px] flex items-center justify-center bg-[#119AE2] text-white sm:py-[6px] sm:px-[14px] p-3 button" +
                `${disabled == "start" ? "disable bg-[#F1F1F1]" : ""}`
              }
              onClick={() => swiper.slidePrev()}
            >
              <LeftOutlined
                style={{ color: disabled == "start" ? "black" : "white" }}
              />
            </button>
            <button
              className={
                "shadow-none sm:w-[38px] sm:h-[38px] w-[16px] h-[16px] rounded-[10px] flex items-center justify-center bg-[#119AE2] text-white sm:py-[6px] sm:px-[14px] p-3 button" +
                `${disabled == "end" ? "disable bg-[#F1F1F1]" : ""}`
              }
              onClick={() => swiper.slideNext()}
            >
              <RightOutlined
                style={{ color: disabled == "end" ? "black" : "white" }}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
